import dynamic from 'next/dynamic';
import { MapProps } from './Map.types';

const Map = dynamic<MapProps>(() => import('./Map'), {
    ssr: false,
});

export default Map;
